import { Button } from "@chakra-ui/react"
import React from "react"

export const SubmitButton = () => {
  return (
    <Button size="lg" variant="primary" type="submit">
      Search
    </Button>
  )
}
